import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyD5nNSyyGKRt112WXwrT1rPrCmvgmws1h0',
  authDomain: 'seameo-icse2021.firebaseapp.com',
  databaseURL: 'https://seameo-icse2021-default-rtdb.firebaseio.com',
  projectId: 'seameo-icse2021',
  storageBucket: 'seameo-icse2021.appspot.com',
  messagingSenderId: '919899848508',
  appId: '1:919899848508:web:35b581537f4bb10726a839',
  measurementId: 'G-PLTP3PPFS9',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.REACT_APP_STAGE === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const ChatKfairDb = getDbRef('chatKfair')
const ChatMcDb = getDbRef('chatMc')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')
const RoomDb = getDbRef('room')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  RoomDb,
  ChatKfairDb,
  ChatMcDb,
  NoticeDb,
  NotificationDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
}
